import React from "react";
import { EaseModal } from "../../../libs/EaseModal";
import { OrderForm } from "../Forms";
import { Text1 } from "../../../styles";

const CreateOrderModal = (props) => {
  const renderTitle = () => {
    return (
      <Text1 className="d-block mb-4" strong>
        {`${props.order.is_edit ? "Edit" : "Create"} Order`}
      </Text1>
    );
  };

  return (
    <EaseModal
      width={500}
      title={false}
      visible={props.visible}
      onCancel={props.toggleCreateOrderModal}
      centered
      hideFooter
      destroyOnClose
    >
      {renderTitle()}
      <OrderForm
        onSubmit={props.onSubmit}
        loading={props.loading}
        virtualAccount={props.virtualAccount}
        order={props.order}
      />
    </EaseModal>
  );
};

export { CreateOrderModal };
